import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const HamburgerMenuIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3 5.85001H21V7.86601H3V5.85001ZM3 12.834V10.866H21V12.834H3ZM3 17.85V15.834H21V17.85H3Z'
                fill='currentColor'
            />
        </>
    ),
})

HamburgerMenuIcon.displayName = 'HamburgerMenuIcon'
